import { HttpClient } from '../api/HttpClient';
import { API_ENDPOINTS } from '../api/ApiConfig';
import type { AppUpdate, AppUpdatesPage, AppUpdatesQueryParams } from '../../types/api/app-update';

export class AppUpdateService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = HttpClient.getInstance();
  }

  async getAppUpdates(params: AppUpdatesQueryParams = {}): Promise<AppUpdatesPage> {
    const queryParams = new URLSearchParams();

    if (params.page !== undefined) {
      queryParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size.toString());
    }

    const url = `${API_ENDPOINTS.APP_UPDATES.ADMIN_LIST}?${queryParams.toString()}`;
    const response = await this.httpClient.get<AppUpdatesPage>(url);

    if (!response.success) {
      throw new Error(response.message || 'Failed to fetch app updates');
    }

    return response.data;
  }

  async createAppUpdate(payload: { appLink: string; versionNumber: string }): Promise<AppUpdate> {
    const response = await this.httpClient.post<AppUpdate>(
      API_ENDPOINTS.APP_UPDATES.ADMIN_CREATE,
      payload
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to create app update');
    }

    return response.data;
  }

  async updateAppUpdate(
    id: string,
    payload: { appLink: string; versionNumber: string }
  ): Promise<AppUpdate> {
    const response = await this.httpClient.put<AppUpdate>(
      API_ENDPOINTS.APP_UPDATES.ADMIN_UPDATE(id),
      payload
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to update app update');
    }

    return response.data;
  }

  async deleteAppUpdate(id: string): Promise<void> {
    const response = await this.httpClient.delete<null>(
      API_ENDPOINTS.APP_UPDATES.ADMIN_DELETE(id)
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to delete app update');
    }
  }

  async getAppUpdate(id: string): Promise<AppUpdate> {
    const response = await this.httpClient.get<AppUpdate>(
      API_ENDPOINTS.APP_UPDATES.ADMIN_DETAILS(id)
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to fetch app update');
    }

    return response.data;
  }
}

